import React, { Component } from 'react';
import { SelectGroupStyle, CalendarTableStyle } from '../PlayerList/PlayerListStyle';
import { ContainerStyle, ClubBadgeBg, FiltersArea, ClubName } from './RaceCalendarStyle';
import Select from '../UI/Select/Select';
import Link from '../UI/Link/Link';
import { Match } from '../../types';
import { Redirect } from "react-router-dom";
import moment from 'moment';
import { groupBy, uniqBy } from 'lodash';
import Button from '../UI/Button/Button';
import Icon from 'antd/lib/icon';
import { Title, TitleType } from '..';
import { BoatSvg } from '../../styles/custom-icons';

const BoatIcon = (props: any) => <Icon component={BoatSvg} {...props} />;

export interface RaceCalendarProps {
	data: any[];
	size: number;
	isLoading?: boolean;
	showMonthsFilter?: boolean;
	assetsCdn?: string;
	weekId: number;
	showHeader?: boolean;
	t: any;
}

export interface RaceCalendarState {
	navigateToMatchId: any,
	weekId: number,
	filters: any,
	filtersActivated: boolean
}

class RaceCalendar extends Component<RaceCalendarProps, RaceCalendarState> {

	constructor(props: RaceCalendarProps) {
		super(props);

		this.state = {
			filters: {
				month: -1
			},
			filtersActivated: true,
			navigateToMatchId: null,
			weekId: props.weekId
		};
	}

	componentDidUpdate(prevProps: RaceCalendarProps) {
		if (this.props.weekId !== prevProps.weekId) {
			this.setState({ weekId: this.props.weekId });
		}
	}


	onFilterChange = (name: string, value: string | number) => {
		const filters: any = Object.assign({}, this.state.filters, { [name]: value });
		this.setState({ filters })
	};

	matchFilter = (match: Match, filters: any) => {
		let show = true;
		if (filters.month !== -1 && filters.month !== moment(match.date).month()) {
			show = false;
		}

		return show;
	};

	enableFilters = (e: any) => {
		this.setState({ filtersActivated: true });
	};

	onCalendarWeekChanged = (weekId: number) => {
		this.setState({ weekId });
	};

	render() {
		moment.locale('en-us');

		const { data, size, showHeader, isLoading, showMonthsFilter, assetsCdn, t } = this.props;
		const { navigateToMatchId, weekId, filtersActivated } = this.state;
		const matchesList = data;		

		const matchDate = moment(matchesList);
		const matchNotStarted = moment().isBefore(matchDate);

		const columns = [
			{
				title: 'Rit',
				key: 'feedUrl',
				dataIndex: 'feedUrl',
				width: '25%',
				render: (text: string, record: any) => {
					const matchDate = moment(record.date);
					const matchNotStarted = moment().isBefore(matchDate);
					return <div className="c-match">
						<div style={{ margin: "0px 10px 0px 10px" }}>
							<h4 style={{ color: '#151820 !important', marginBottom: "-10px" }} className="c-match-collection__subtitle">{moment(matchDate).format('DD')}</h4>
							<span style={{ backgroundColor: "#f1f1f1", color: "#151820", borderRadius: "50px", padding: "2px 8px 2px 8px" }}>{moment(matchDate).format('MMM').toUpperCase()}</span>
						</div>
					</div>;
				}
			},
			{
				title: 'Match',
				key: 'id',
				dataIndex: 'id',
				width: '75%',
				render: (index: any, record: any) => {
					return <div className="c-match__team">
						<span style={{ color: '#151820 !important', fontSize: '16px', fontWeight: 600 }} className="c-link c-card__link--neutral">{record.feedUrl}</span>
					</div>;
				}
			}
		];

		return (
			<ContainerStyle>
				{navigateToMatchId && <Redirect
					to={{ pathname: `/match/${navigateToMatchId}` }}
				/>}
				{
					<React.Fragment>
						<CalendarTableStyle
							columns={columns}
							dataSource={matchesList}
							showHeader={false}
							locale={{ emptyText: 'No matches found.' }}
							loading={isLoading}
							pagination={matchesList.length > size ? { pageSize: size } : false}
							rowKey={(record: any, index: number) => `record-${index + 1}`}
							rowClassName={(record: object, index: number) =>
								index % 2 ? 'ant-table-row--odd' : 'ant-table-row--even'
							}
						/>
					</React.Fragment>
				}
			</ContainerStyle>
		);
	}
}

export default RaceCalendar;
